module.exports = __webpack_public_path__ + "img/cover.ca03a1d2.jpg";